import produce from 'immer';
import {
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE,
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST,
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_SUCCESS,
  ARTICULOS_FILTROS_REQUEST,
  ARTICULOS_FILTROS_SUCCESS,
  ARTICULOS_FILTROS_FAILURE,
} from '../actions/constants/articulos.constants';

const initialState = {
  imagenes: {},
  filtros: {},
};

export default function articulosReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST: {
      const { articulos } = payload;
      return produce(state, (draft) => {
        [...articulos].forEach((articulo) => {
          if (articulo !== null && articulo !== undefined) {
            const {
              codigo, codigo_barra, codigo_EDI, fabricante_id,
            } = articulo;
            // eslint-disable-next-line eqeqeq
            if (draft.imagenes[codigo] === undefined) {
              draft.imagenes[codigo] = {
                loading: true,
                codigo_barra,
                codigo,
                codigo_EDI,
                fabricante_id,
              };
            } else {
              draft.imagenes[codigo].loading = true;
            }
          }
        });
        return draft;
      });
    }
    case IMAGENES_ARTICULOS_OBTENER_IMAGENES_SUCCESS: {
      const { imagenes } = payload;
      return produce(state, (draft) => {
        imagenes.forEach(({ codigo, src }) => {
          draft.imagenes[codigo].src = src;
          draft.imagenes[codigo].loading = false;
        });
        return draft;
      });
    }
    case IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE: {
      const { codigos } = payload;
      return produce(state, (draft) => {
        if (codigos === undefined) return draft;
        codigos.forEach(({ codigo }) => {
          draft.imagenes[codigo] = {
            loading: false,
          };
        });
        return draft;
      });
    }
    case ARTICULOS_FILTROS_REQUEST: {
      const { filtros } = payload;
      return { ...state, filtros: filtros };
    }
    case ARTICULOS_FILTROS_SUCCESS: {
      const { filtros } = payload;
      return { ...state, filtros: filtros };
    }
    case ARTICULOS_FILTROS_FAILURE: {
      return { ...state };
    }
    default:
      return state;
  }
}
